import fetch from 'isomorphic-fetch'

class TopicActionsApi {
  static requestHeaders() {
    return {
      'Content-Type': 'application/json'
    }
  }

  static getAll(id) {
    const headers = this.requestHeaders()

    return fetch(`${process.env.REACT_APP_API_HOST}/topics/${id}/actions`, {
      method: 'GET',
      headers: headers
    })
      .then(response => response.json().then(json => ({ json, response })))
      .catch(error => {
        return error
      })
  }
}

export default TopicActionsApi
